// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { valueFromMeters } from 'helpers/unitConversion'
import { convertDDtoDMSPref } from 'helpers/coordsConversion'
import scrubAntennas from './scrubAntennas'
import scrubRadio from './scrubRadio'
import { roundAndCastToString } from 'helpers/reduxFormFunctions'

// s is a pathsearchDTO segment end.
// meaning it is a segment end but
// it has less detail than a segmentEndDetails DTO.

const scrubSiteSummary = (s, unitType) => {
  const {
    asr,
    callSign,
    numberOfFrequencies,
    segmentEndId,
    contactId = null,
    radioServiceId,
    segmentEndFrequencyPlan,
    siteName,
  } = s

  const antennas = scrubAntennas(s, unitType)
  const bandwidth = roundAndCastToString(
    s.segmentEndRadioModulation.bandwidth,
    1
  )

  const latitude = convertDDtoDMSPref(s.latitude, 'latitude')
  const longitude = convertDDtoDMSPref(s.longitude, 'longitude')
  // first this determines if it needs to convert to ft
  // then rounds to the tenth decimal place
  const groundElevation = roundAndCastToString(
    valueFromMeters(s.groundElevation, unitType),
    2
  )

  const radio = scrubRadio(s)
  const segmentStatus = s.segmentStatus || ''
  const serviceContactCode = s.serviceContactCode || ''
  const stateCode = s.stateCode || ''

  // we want to know this so we can bold HI sites.
  const pairDesignation = segmentEndFrequencyPlan?.pairDesignation || ''

  return {
    antennas,
    asr,
    bandwidth,
    callSign,
    contactId,
    groundElevation,
    latitude,
    longitude,
    numberOfFrequencies,
    pairDesignation,
    radio,
    radioServiceId,
    segmentEndId,
    segmentStatus,
    serviceContactCode,
    siteName,
    stateCode,
  }
}

export default scrubSiteSummary
